/* REVIVE WEB V2. COMPRAR AHORA: del producto al pago, sin pasar por el carrito.
 *
 * El problema que resuelve: `product-form.js` de Dawn escucha el `submit` del
 * formulario, hace `preventDefault()` y anade por AJAX, abriendo el carrito.
 * Para este boton eso es justo lo contrario de lo que queremos.
 *
 * La salida es `HTMLFormElement.prototype.submit()`, que envia el formulario
 * SIN disparar el evento `submit`, asi que el escuchador de Dawn no llega a
 * ejecutarse. Como el submit nativo no incluye el par name/value del boton que
 * lo disparo, el `return_to` se anade a mano como campo oculto.
 *
 * Sin este archivo el boton sigue funcionando: es un submit normal y el
 * navegador ya envia `return_to=/checkout`. Esto solo cubre el caso con JS.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (evento) {
    var boton = evento.target.closest('[data-rv-comprar-ahora]');
    if (!boton || boton.disabled) return;

    var formulario = boton.form || boton.closest('form');
    if (!formulario) return;

    evento.preventDefault();

    // Un solo envio: el POST recarga la pagina, asi que basta con bloquear el
    // segundo disparo y dejar constancia visual de que se esta procesando.
    if (boton.dataset.rvEnviando === 'true') return;
    boton.dataset.rvEnviando = 'true';
    boton.setAttribute('aria-busy', 'true');

    if (!formulario.querySelector('input[name="return_to"]')) {
      var destino = document.createElement('input');
      destino.type = 'hidden';
      destino.name = 'return_to';
      destino.value = boton.value || '/checkout';
      formulario.appendChild(destino);
    }

    // Submit nativo: no dispara el evento, asi que Dawn no lo intercepta.
    HTMLFormElement.prototype.submit.call(formulario);
  });
})();
